import { Button } from 'flowbite-react';
import { useLocation, useNavigate } from 'react-router-dom';
import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { UIVideoResume } from 'types';
import { sendTrackingEvent } from 'src/utils/gtm';
import ProfileContentHeader from './ProfileContentHeader';

interface PersonalityProps {
	id: string;
	title: string;
	userVideos: UIVideoResume;
	isSelf: boolean;
}

export const responsive = {
	superLargeDesktop: {
		breakpoint: { max: 4000, min: 3000 },
		items: 5,
	},
	desktop: {
		breakpoint: { max: 3000, min: 1220 },
		items: 3,
	},
	tablet: {
		breakpoint: { max: 1220, min: 764 },
		items: 2,
	},
	mobile: {
		breakpoint: { max: 764, min: 0 },
		items: 1,
	},
};

const ProfilePersonalitySection = ({ title, id, userVideos, isSelf }: PersonalityProps) => {
	const location = useLocation();
	const navigate = useNavigate();

	return !isSelf && userVideos ? null : (
		<>
			<ProfileContentHeader data={{ name: title, isImp: false }} />
			<div
				id={id}
				className="flex w-full flex-col gap-2 overflow-hidden rounded-xl bg-transparent dark:bg-[#1F2A37] p-3 pb-2"
			>
				<div className="p-2">
					{userVideos && userVideos?.urls?.questionMapping?.length ? (
						<Carousel responsive={responsive}>
							{userVideos.urls.questionMapping.map((video: { url: string; question: string }) => (
								<div className="mx-auto flex w-[254px] flex-col gap-y-3 sm:max-w-[320px]" key={video?.question}>
									<div className="h-[200px] w-full overflow-hidden rounded-[8px]">
										<video controls autoPlay={false} className="video-container h-full w-full object-contain">
											<source src={video.url} type="video/mp4" />
										</video>
									</div>
									<div className="flex flex-col gap-y-[6px] font-inter text-black dark:text-white">
										<p>{video?.question}</p>
									</div>
								</div>
							))}
						</Carousel>
					) : (
						<div className="">
							{!isSelf ? (
								<p className="px-4 py-5 text-center font-inter text-[14px] font-[500] text-[#28293D] dark:text-[#C7C9D9]">
									There&apos;s nothing to show.
								</p>
							) : (
								<>
									<div className="flex justify-center">
										<p className="max-w-[470px] text-center font-inter text-[14px] text-[#28293D] font-[500] dark:text-[#C7C9D9]">
											Personality is determined through a video resume that enables recruiters to gain insight into your
											behavioural aspects.
										</p>
									</div>
									<div className="mt-[12px] flex justify-center">
										<Button
											color="purplePlaced"
											onClick={() => {
												sendTrackingEvent({
													event: 'profile_start_recording',
													eventLabel: location.pathname,
												});
												navigate(`/video-resume`);
											}}
										>
											Start Recording
										</Button>
									</div>
								</>
							)}
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default ProfilePersonalitySection;
